<template>
  <div class="containerDiv" >
    <PCNavbar :selectIndex="currentActiveNum"/>
    <MobileNavBar :currentActive="2"/>
     <!-- 头部banner图片 -->
    <!-- otherType -->
     <img v-if="this.title == '新闻动态详情' && !this.otherType" class="bannerImgcss0" src="../../assets/w/img3/rencaijiaoliu/rencaizhaopin-bg.png" />
     <a v-else-if="this.title == '学习贯彻党的二十届四中全会精神' && !this.otherType " href="https://www.qstheory.cn/zt2025/esjszqh/index.htm"  target="_blank" >
        <img  class="bannerImgcss0" src="../../assets/w/img3/dangjian/dangjianBg1.png" />
     </a>
     
    <img class="top-bg bannerImgcss0" v-else-if="this.title == '企务公开' || this.title == '采购信息' "  src="../../assets/img3/msgpublic/lingdaoxinxi-bg.png" alt="领导信息背景图">


    <img v-if="!!this.otherType" class="bannerImgcss0" src="../../assets/w/img3/dangjian/dangjianBg2.png" />

    <!-- 二级菜单切换 -->
     <div class="mainbody menus">
      <a href="/home"><i class="el-icon-s-home"></i></a> / <a style="color: #666;">{{ title }}</a>
      <span class="fontsizeCssy">字体 【 <em @click="fontsize='big'">大</em> <em @click="fontsize='default'">中</em> <em @click="fontsize='small'">小</em> 】</span>
 
    </div>
      <!-- 新闻动态三级页面(详情界面) -->
      <div class="articleDetailDiv" >
            <h1 class="fontSizeTitle">{{ articleDetail.title }}</h1>
            <p class="fontSizeTtme" v-if="articleDetail.createDate">发布时间：{{ articleDetail.createDate.substring(0,16) }}   
              <span v-if="!!articleDetail.copyfrom" style="padding-left: 10px;padding-right:10px;">     来源：{{ articleDetail.copyfrom }}</span></p>
            <div :class="this.fontsize=='big'?'contentcss0 contentcss0big':this.fontsize=='small'?'contentcss0 contentcss0small':'contentcss0'" v-blank-link v-html="articleDetail.content" ></div>
        </div>

          <!-- 新增上下篇导航 -->
          <!-- <div class="detail-pagination">
            <div class="pagination-bg">
              <div class="prev-article">
                <template  >
                  <span class="pagination-label">上一篇：</span>
                  <a class="article-title">111</a>
                </template>
                <template  >
                  <span class="pagination-label">上一篇：</span>
                  <span class="no-article">没有了</span>
                </template>
              </div>
              <div class="next-article">
                <template v-if="nextArticle">
                  <span class="pagination-label">下一篇：</span>
                  <a   class="article-title">222</a>
                </template>
                <template v-else>
                  <span class="pagination-label">下一篇：</span>
                  <span class="no-article">没有了</span>
                </template>
              </div>
            </div>
          </div> -->
    </div>
</template>

<script>
import API from '@/api/index'

 
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
  
export default {
  components: {
    PCNavbar,
    MobileNavBar,
      
  },
  data() {
    return {
      otherType:null,
      fontsize:'default',
      artId:'',
      articleDetail:[],
      title:'',
      currentActiveNum:0,
    }
  },
  created(){
    console.log(this.$route.query.artId)
    this.artId=this.$route.query.artId
    this.otherType=this.$route.query.otherType
    var zl=this.$route.query.zl
    if(!!zl && zl == '1'){
      if(!this.otherType){
           this.title='学习贯彻党的二十届四中全会精神'
      }else{
        this.title='树立和践行正确政绩观学习教育专栏'
      }
     
    }else if(!!zl && zl == 'infoOpen'){
      this.title='企务公开'
      this.currentActiveNum='5'
    }else if(!!zl && zl == 'cgList'){
       this.title='采购信息'
       this.currentActiveNum='5'
    }else{
      this.title='新闻动态详情'
    }
  },
  mounted(){
    this.goArticleDetail()
  },
  methods:{
     // 新闻动态获取三级页面详情页
     async goArticleDetail(obj) {
      this.cengji=2
      try {
       
      
        if( this.title=='采购信息'){
               let objParams={
          proId:this.artId,
        }
          const res = await API.cgDetail(objParams)
          this.articleDetail=res.data.procorement
        }else{
       
          let objParams={
          artId:this.artId,
        }
          const res = await API.getArticleData(objParams)
          this.articleDetail=res.data.list[0]
        }
        
       
      } catch (error) {
        console.error('获取失败', error)
      }
      },
    
    
    
  }
 

}
</script>
 
<style lang="scss" scoped>
.containerDiv{
  // margin-bottom:8rem;
  @media screen and (max-width: 768px) {
    margin-bottom:0;
  }
}
.bannerImgcss0{
  width:100%;
  // margin-top:50px;
  height:auto;
} 

.mainbody{
  width: 90%;
  margin:0 auto;
  background:#ffffff;
 }
//  .menus{
//   padding:1rem;
//   font-size:1rem;
//   padding-left:0;
//  }

 .Lmenu{
  margin-top:1rem;
  // padding:1rem;
  margin-bottom:0.5rem;
  font-size:1rem;
  background:#eee;
  text-align:center;
  a{
    display: block;
    width: 100%;
    padding:1rem;
    // background: #d38220;
    color:#666;
  }
 }
 .active{
    background:#2091d3;
    a{
      color:#ffffff;
   }
  }
 .Rcontent{
  display:flexbox;
  padding:1rem;
  padding-top:0;
  background:#ffffff;
  margin-left:3.5rem;
  @media screen and (max-width: 768px) {
    margin-left:0;
  }
    ul{
      li{
        list-style:none;
        // padding:1rem;
        line-height:1rem;
        border-bottom:1px solid #e5e5e5;
        display:flex;
        .Rtime{
          flex:5%;
          padding:0.8rem;
          background:#e5e5e5;
          font-size:1rem;
          font-weight:bold;
          color:#dab773;
        }
        .Rtitle{
          flex:85%;
          padding:1.3rem;
          font-size:0.9rem;
          a{
            color:#333;
          }
        }
      }
      li.lastLi{
        border-bottom:none;
      }
    }
 }
 .articleDetailDiv{
    width: 90vw;
    margin: 0 auto;
    padding:0 70px 50px;
    border:  1px solid #e5e5e5;
    margin-bottom: 1rem;
    // border: 1px solid #999999;
    h1{
      width: 80%;
      margin:0 auto;
      margin-bottom: 1rem;
      border-bottom: 1px solid #999999;
      text-align: center;
      padding:1rem 0;
    }
    p{
      text-align: center;
    }
    div.contentcss0{
      margin: 0 auto;
      margin-top: 1rem;
      color: #000000;
      @media screen and (max-width:768px) {
        *{
          font-size: 0.5rem !important;
        }
     }
       
    }
    // 重置字体样式001
    div.contentcss0 :not(.keep-style) {
      // width: 90%;
      margin: 0 auto !important;
      // margin-top: 1rem;
      font-size:18PX !important;
      line-height: 2em !important;
      text-indent:2em !important;
      text-align: justify !important;
      word-break: break-all !important;
      // text-align: left !important;
      @media (min-width: 0px) and (max-width: 991px) {
      span img{
          margin-left: -28px!important;
        }
      }
    }
  }

   // 重置图片样式 002
   div.contentcss0  img {
    border: var(--img-border, none) !important;
    width: var(--img-width, auto) !important;
    height: var(--img-height, auto) !important;
  }

  /* 使用深度选择器（Vue 2/3 兼容写法） */
  .contentcss0 >>> img,.contentcss0 ::v-deep img,.contentcss0 :deep(img) {
    border: none !important; /* 移除边框 */
    padding: 0 !important;
    // margin: 0!important;
    box-shadow: none !important;
    display: block;
    margin:0 auto !important;
    width: 50% !important;
  }
  .contentcss0 >>> table,.contentcss0 ::v-deep table,.contentcss0 :deep(table) {
    
    margin:0 auto !important;
    width: 60% !important;
  }

  .change_page{
    width: 90%;
    margin: 0 auto;
    margin-top: 1rem;
  }
 
  .detail-pagination {
    width: 90%;
    margin: 0 auto;
    margin: 2rem auto 0;
    padding: 1rem 0;
    border-top: 1px solid #eee;
  
    .pagination-bg {
      background: #f8f8f8;
      padding: 1.2rem;
      border-radius: 4px;
    }
  
    .prev-article, .next-article {
      line-height: 1.8;
      font-size: 0.95rem;
      
      + .next-article {
        margin-top: 0.8rem;
      }
    }
  
    .pagination-label {
      color: #999;
      margin-right: 0.5rem;
    }
  
    .article-title {
      color: #333;
      cursor: pointer;
      transition: color 0.3s;
  
      &:hover {
        color: #2091d3;
        text-decoration: underline;
      }
    }
  
    .no-article {
      color: #999;
    }
  }

  .articleDetailDiv {
    div.contentcss0big :not(.keep-style) {
        font-size: 20PX !important;
        color: #000000;
    }

    div.contentcss0small :not(.keep-style) {
        font-size: 16PX !important;
        color: #000000;
    }
}
</style>
